// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/analytics--app--src--analytics--inbound-dashboard.json";
import part1 from "./en/analytics--app--src--analytics--returns-claims--claim--components--carriers.json";
import part2 from "./en/analytics--app--src--analytics--returns-claims--claim--components.json";
import part3 from "./en/analytics--app--src--analytics--returns-claims--claim--hooks.json";
import part4 from "./en/analytics--app--src--analytics--returns-claims--insights.json";
import part5 from "./en/analytics--app--src--analytics--returns-claims--operations.json";
import part6 from "./en/analytics--app--src--analytics--returns-claims--overview--components.json";
import part7 from "./en/analytics--app--src--analytics--returns-claims--overview.json";
import part8 from "./en/analytics--app--src--analytics--returns-claims--portal--components--hooks.json";
import part9 from "./en/analytics--app--src--analytics--returns-claims--portal--components.json";
import part10 from "./en/analytics--app--src--analytics--returns-claims--portal.json";
import part11 from "./en/analytics--app--src--analytics--returns-claims--product--components--filters.json";
import part12 from "./en/analytics--app--src--analytics--returns-claims--product--components--table--configs.json";
import part13 from "./en/analytics--app--src--analytics--returns-claims--product--components--table.json";
import part14 from "./en/analytics--app--src--analytics--returns-claims--product--components.json";
import part15 from "./en/analytics--app--src--analytics--returns-claims--product.json";
import part16 from "./en/analytics--app--src--analytics--returns-claims--returns--components.json";
import part17 from "./en/analytics--app--src--analytics--returns-claims--returns--hooks.json";
import part18 from "./en/analytics--app--src--analytics--returns-claims--returns.json";
import part19 from "./en/analytics--app--src--analytics--returns-claims--shared.json";
import part20 from "./en/analytics--app--src--analytics--returns-claims.json";
import part21 from "./en/analytics--app--src--analytics.json";
import part22 from "./en/app-common--src--components--tax-identifiers.json";
import part23 from "./en/app-common--src--components--translations.json";
import part24 from "./en/app-common--src--dns.json";
import part25 from "./en/app-common--src--setting.json";
import part26 from "./en/app-common--src--settings.json";
import part27 from "./en/app-common--src--support.json";
import part28 from "./en/app-common--src--tag.json";
import part29 from "./en/app-common--src--walkthrough.json";
import part30 from "./en/customer--app--src--action-panel.json";
import part31 from "./en/customer--app--src--all-customers--components.json";
import part32 from "./en/customer--app--src--customer-detail--customer-activity--cards.json";
import part33 from "./en/customer--app--src--customer-detail--customer-activity--feed-entry.json";
import part34 from "./en/customer--app--src--customer-detail--customer-activity.json";
import part35 from "./en/customer--app--src--customer-detail.json";
import part36 from "./en/customer--app--src--customer-journey--components--custom-event-components.json";
import part37 from "./en/customer--app--src--customer-journey--components--customer-journey-table.json";
import part38 from "./en/customer--app--src--customer-journey--constants.json";
import part39 from "./en/customer--app--src--customer-journey.json";
import part40 from "./en/customer--app--src--customer-record--components.json";
import part41 from "./en/customer--app--src--customer-record.json";
import part42 from "./en/customer--app--src--loyalty.json";
import part43 from "./en/customer--app--src.json";
import part44 from "./en/general--app--src--gift-receipt-requests.json";
import part45 from "./en/general--app--src--inmar-blind-returns.json";
import part46 from "./en/general--app--src--setting--brand-kit.json";
import part47 from "./en/general--app--src--setting--communication.json";
import part48 from "./en/general--app--src--setting--customer-portal-builder--ai.json";
import part49 from "./en/general--app--src--setting--customer-portal-builder--center-stage.json";
import part50 from "./en/general--app--src--setting--customer-portal-builder--header.json";
import part51 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--address.json";
import part52 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--ai-exchange-recommendations.json";
import part53 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--cant-find-item.json";
import part54 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--compensation-method.json";
import part55 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--confirmation.json";
import part56 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--contact-information.json";
import part57 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--item-details.json";
import part58 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--login.json";
import part59 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--order-details.json";
import part60 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--purchase-channel.json";
import part61 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--registration-address.json";
import part62 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--registration-catalog.json";
import part63 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--return-type.json";
import part64 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--review.json";
import part65 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--select-items.json";
import part66 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages--shipment-method.json";
import part67 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--pages.json";
import part68 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings--translations.json";
import part69 from "./en/general--app--src--setting--customer-portal-builder--left-panel--settings.json";
import part70 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles--branding.json";
import part71 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles--global-cards.json";
import part72 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles--selection-cards.json";
import part73 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--buttons.json";
import part74 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--general.json";
import part75 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--selection.json";
import part76 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2--typography.json";
import part77 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles-v2.json";
import part78 from "./en/general--app--src--setting--customer-portal-builder--left-panel--styles.json";
import part79 from "./en/general--app--src--setting--customer-portal-builder--left-panel.json";
import part80 from "./en/general--app--src--setting--customer-portal-builder--right-panel.json";
import part81 from "./en/general--app--src--setting--customer-portal-builder.json";
import part82 from "./en/general--app--src--setting--customer-portal.json";
import part83 from "./en/general--app--src--setting--developer--components.json";
import part84 from "./en/general--app--src--setting--developer--modals.json";
import part85 from "./en/general--app--src--setting--developer.json";
import part86 from "./en/general--app--src--setting--notification--tabs.json";
import part87 from "./en/general--app--src--setting--notification.json";
import part88 from "./en/general--app--src--setting--roles.json";
import part89 from "./en/general--app--src--setting--user.json";
import part90 from "./en/general--app--src--setting--withdrawals.json";
import part91 from "./en/marketing--app--src--marketing-agent.json";
import part92 from "./en/marketing--app--src--text-concierge--settings.json";
import part93 from "./en/review--app--src--settings.json";
import part94 from "./en/src--app--banner--notifications.json";
import part95 from "./en/src--app--navigation--routing--settings-routes.json";
import part96 from "./en/src--app--navigation--routing.json";
import part97 from "./en/src--app--navigation--side-navigation--aeo.json";
import part98 from "./en/src--app--navigation--side-navigation--conversion.json";
import part99 from "./en/src--app--navigation--side-navigation--customers.json";
import part100 from "./en/src--app--navigation--side-navigation--developer.json";
import part101 from "./en/src--app--navigation--side-navigation--global-search-tools.json";
import part102 from "./en/src--app--navigation--side-navigation--home.json";
import part103 from "./en/src--app--navigation--side-navigation--inventory.json";
import part104 from "./en/src--app--navigation--side-navigation--marketing.json";
import part105 from "./en/src--app--navigation--side-navigation--orders.json";
import part106 from "./en/src--app--navigation--side-navigation--payments.json";
import part107 from "./en/src--app--navigation--side-navigation--redo-supplies.json";
import part108 from "./en/src--app--navigation--side-navigation--returns.json";
import part109 from "./en/src--app--navigation--side-navigation--shipping.json";
import part110 from "./en/src--app--navigation--side-navigation--shopper-agent.json";
import part111 from "./en/src--app--navigation--side-navigation--support.json";
import part112 from "./en/src--app--navigation--side-navigation.json";
import part113 from "./en/src--app--navigation--top-navigation.json";
import part114 from "./en/src--app.json";
import part115 from "./en/src--components.json";
import part116 from "./en/src--feature-onboarding--onboarding-cards.json";
import part117 from "./en/src--feature-onboarding--onboarding-modals.json";
import part118 from "./en/src--feature-onboarding--withdrawals-onboarding.json";
import part119 from "./en/src--homepage.json";
import part120 from "./en/src--integrations--catalog.json";
import part121 from "./en/src--integrations--components--configs.json";
import part122 from "./en/src--integrations--components--hooks.json";
import part123 from "./en/src--integrations--components--integration-cards.json";
import part124 from "./en/src--integrations--components--shared.json";
import part125 from "./en/src--integrations--components.json";
import part126 from "./en/src--integrations--pages.json";
import part127 from "./en/src--integrations--panels--activation-sections.json";
import part128 from "./en/src--integrations--panels.json";
import part129 from "./en/src--onboarding.json";
import part130 from "./en/src--order--action-panel.json";
import part131 from "./en/src--order--hooks.json";
import part132 from "./en/src--order--order-details--stat-cards.json";
import part133 from "./en/src--order--order-details--tnpl-timeline.json";
import part134 from "./en/src--order--order-details.json";
import part135 from "./en/src--order--orders-table.json";
import part136 from "./en/src--order-sync-progress.json";
import part137 from "./en/src--order-tracking--orders.json";
import part138 from "./en/src--order.json";
import part139 from "./en/src--payments--chargebacks--settings.json";
import part140 from "./en/src--plg-homepage.json";
import part141 from "./en/src--plg.json";
import part142 from "./en/src--registration--customer-tabs.json";
import part143 from "./en/src--registration.json";
import part144 from "./en/src--return--action-panel.json";
import part145 from "./en/src--return--bulk-actions--bar.json";
import part146 from "./en/src--return--bulk-actions--modals.json";
import part147 from "./en/src--return--bulk-actions--model.json";
import part148 from "./en/src--return--bulk-actions--toasts.json";
import part149 from "./en/src--return--bulk-actions.json";
import part150 from "./en/src--return--edit-item-disposition.json";
import part151 from "./en/src--return--fraud.json";
import part152 from "./en/src--return--hooks.json";
import part153 from "./en/src--return--restock-bins.json";
import part154 from "./en/src--return--return-detail-cards.json";
import part155 from "./en/src--return--return-modals--common.json";
import part156 from "./en/src--return--return-modals--create-label--components.json";
import part157 from "./en/src--return--return-modals--create-label.json";
import part158 from "./en/src--return--return-modals--new-edit-modal.json";
import part159 from "./en/src--return--return-modals--new-process-modal--components--item-edit.json";
import part160 from "./en/src--return--return-modals--new-process-modal--components--item-rows.json";
import part161 from "./en/src--return--return-modals--new-process-modal--components--modals.json";
import part162 from "./en/src--return--return-modals--new-process-modal--components--summary.json";
import part163 from "./en/src--return--return-modals--new-process-modal--utils.json";
import part164 from "./en/src--return--return-modals--new-process-modal.json";
import part165 from "./en/src--return--return-modals--return-adjustment-modal.json";
import part166 from "./en/src--return--return-modals.json";
import part167 from "./en/src--return--return-page-left-panel--item-picker.json";
import part168 from "./en/src--return--return-page-left-panel--product-assessments.json";
import part169 from "./en/src--return--return-page-left-panel--return-item--expanded-content.json";
import part170 from "./en/src--return--return-page-left-panel--return-item--hooks.json";
import part171 from "./en/src--return--return-page-left-panel--return-item--return-item-summary--components.json";
import part172 from "./en/src--return--return-page-left-panel--return-item.json";
import part173 from "./en/src--return--return-page-left-panel--return-new-item--hooks.json";
import part174 from "./en/src--return--return-page-left-panel--return-new-item.json";
import part175 from "./en/src--return--return-page-left-panel.json";
import part176 from "./en/src--return--return-page-right-panel--customer-tabs.json";
import part177 from "./en/src--return--return-page-right-panel--shipping-details--components.json";
import part178 from "./en/src--return--return-page-right-panel--shipping-details--utils.json";
import part179 from "./en/src--return--return-page-right-panel--shipping-details.json";
import part180 from "./en/src--return--return-page-right-panel--summary-card--components.json";
import part181 from "./en/src--return--return-page-right-panel--summary-card.json";
import part182 from "./en/src--return--return-page-right-panel.json";
import part183 from "./en/src--return--tags.json";
import part184 from "./en/src--return--views.json";
import part185 from "./en/src--return--walkthrough.json";
import part186 from "./en/src--return--withdrawals.json";
import part187 from "./en/src--return.json";
import part188 from "./en/src--setting--about-tracking.json";
import part189 from "./en/src--setting--ai-agent--components.json";
import part190 from "./en/src--setting--ai-agent.json";
import part191 from "./en/src--setting--aims360-settings.json";
import part192 from "./en/src--setting--apparel-magic-settings.json";
import part193 from "./en/src--setting--aptos-settings--hooks.json";
import part194 from "./en/src--setting--aptos-settings.json";
import part195 from "./en/src--setting--assessments.json";
import part196 from "./en/src--setting--attribute-definitions.json";
import part197 from "./en/src--setting--attribution.json";
import part198 from "./en/src--setting--authorizenet-settings.json";
import part199 from "./en/src--setting--automation--processing--flows.json";
import part200 from "./en/src--setting--automation--processing.json";
import part201 from "./en/src--setting--automation.json";
import part202 from "./en/src--setting--billing--order-tracking.json";
import part203 from "./en/src--setting--billing--outbound-labels-ledger.json";
import part204 from "./en/src--setting--billing--payment-methods.json";
import part205 from "./en/src--setting--billing--products--ims.json";
import part206 from "./en/src--setting--billing--products--returns.json";
import part207 from "./en/src--setting--billing--products--support.json";
import part208 from "./en/src--setting--billing--products.json";
import part209 from "./en/src--setting--billing--video-announcement.json";
import part210 from "./en/src--setting--billing.json";
import part211 from "./en/src--setting--blue-cherry-settings.json";
import part212 from "./en/src--setting--blue-yonder-settings--hooks.json";
import part213 from "./en/src--setting--blue-yonder-settings.json";
import part214 from "./en/src--setting--brightpearl-settings.json";
import part215 from "./en/src--setting--bubblehouse-settings.json";
import part216 from "./en/src--setting--bundles.json";
import part217 from "./en/src--setting--catalog--integrations.json";
import part218 from "./en/src--setting--channel--cloudx-setting.json";
import part219 from "./en/src--setting--channel--voice-and-sms--tabs.json";
import part220 from "./en/src--setting--channel--voice-and-sms.json";
import part221 from "./en/src--setting--channel.json";
import part222 from "./en/src--setting--chargebacks.json";
import part223 from "./en/src--setting--cin7-omni-settings.json";
import part224 from "./en/src--setting--cloudx-settings--hooks.json";
import part225 from "./en/src--setting--cloudx-settings.json";
import part226 from "./en/src--setting--comment-sold-settings.json";
import part227 from "./en/src--setting--commerce-cloud-settings.json";
import part228 from "./en/src--setting--controlport-settings.json";
import part229 from "./en/src--setting--conversation-tags--data.json";
import part230 from "./en/src--setting--conversation-tags.json";
import part231 from "./en/src--setting--conversion--cart-optimization.json";
import part232 from "./en/src--setting--conversion--custom-js.json";
import part233 from "./en/src--setting--conversion--general--delivery-estimate.json";
import part234 from "./en/src--setting--conversion--general.json";
import part235 from "./en/src--setting--conversion--hsa.json";
import part236 from "./en/src--setting--conversion--selector-placement.json";
import part237 from "./en/src--setting--conversion--try-first.json";
import part238 from "./en/src--setting--conversion.json";
import part239 from "./en/src--setting--cordial-settings.json";
import part240 from "./en/src--setting--coverage--coverage-builder--ai.json";
import part241 from "./en/src--setting--coverage--coverage-builder.json";
import part242 from "./en/src--setting--coverage.json";
import part243 from "./en/src--setting--creditsyard-settings.json";
import part244 from "./en/src--setting--custom-return-settings--hooks.json";
import part245 from "./en/src--setting--custom-return-settings.json";
import part246 from "./en/src--setting--customer-accounts--ad-blocks.json";
import part247 from "./en/src--setting--customer-accounts--integrations.json";
import part248 from "./en/src--setting--customer-accounts.json";
import part249 from "./en/src--setting--customer-satisfaction--hooks.json";
import part250 from "./en/src--setting--customer-satisfaction--panels.json";
import part251 from "./en/src--setting--customer-satisfaction.json";
import part252 from "./en/src--setting--customer-widget--tabs--general-tab.json";
import part253 from "./en/src--setting--customer-widget--tabs.json";
import part254 from "./en/src--setting--customer-widget.json";
import part255 from "./en/src--setting--deposco-settings.json";
import part256 from "./en/src--setting--ecwid-settings.json";
import part257 from "./en/src--setting--exchange-agent-guidance--hooks.json";
import part258 from "./en/src--setting--exchange-agent-guidance--modals.json";
import part259 from "./en/src--setting--exchange-agent-guidance.json";
import part260 from "./en/src--setting--exchange.json";
import part261 from "./en/src--setting--exchanges--cards.json";
import part262 from "./en/src--setting--exchanges.json";
import part263 from "./en/src--setting--extensiv-settings.json";
import part264 from "./en/src--setting--flexport-settings.json";
import part265 from "./en/src--setting--flow-editor--advanced-flow-editor--components.json";
import part266 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--common.json";
import part267 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--oms.json";
import part268 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--rules.json";
import part269 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes--work-order.json";
import part270 from "./en/src--setting--flow-editor--advanced-flow-editor--nodes.json";
import part271 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--block-checkout.json";
import part272 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--checkout-experience.json";
import part273 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--common.json";
import part274 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--hsa.json";
import part275 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--inspectors.json";
import part276 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--oms.json";
import part277 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--post-purchase-page.json";
import part278 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--post-purchase-segment.json";
import part279 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--post-purchase-split.json";
import part280 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--address-properties.json";
import part281 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--cart-value.json";
import part282 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--checkout-probability.json";
import part283 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--compound.json";
import part284 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--cross-border-shipment.json";
import part285 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--customer-order-count.json";
import part286 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--customer-return-rate.json";
import part287 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--customer-tags.json";
import part288 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--datetime-range.json";
import part289 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--delivery-distance-miles.json";
import part290 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--delivery-location.json";
import part291 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--historical-order-value.json";
import part292 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--item-quantity.json";
import part293 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--line-item-properties.json";
import part294 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--origin-location.json";
import part295 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--po-box-shipment.json";
import part296 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-collections.json";
import part297 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-metafields.json";
import part298 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-sku.json";
import part299 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-tags.json";
import part300 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--product-vendor.json";
import part301 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--shipment-weight.json";
import part302 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment--time-of-day.json";
import part303 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-segment.json";
import part304 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rco-split.json";
import part305 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--rules.json";
import part306 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--supplies.json";
import part307 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--tracking-page.json";
import part308 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--trigger-steps.json";
import part309 from "./en/src--setting--flow-editor--advanced-flow-editor--steps--work-order.json";
import part310 from "./en/src--setting--flow-editor--advanced-flow-editor--steps.json";
import part311 from "./en/src--setting--flow-editor--advanced-flow-editor--utils.json";
import part312 from "./en/src--setting--flow-editor--advanced-flow-editor.json";
import part313 from "./en/src--setting--flow-editor--compensation-flow.json";
import part314 from "./en/src--setting--flow-editor--components--flow-agent.json";
import part315 from "./en/src--setting--flow-editor--components.json";
import part316 from "./en/src--setting--flow-editor--restocking-flow.json";
import part317 from "./en/src--setting--flow-editor--utils.json";
import part318 from "./en/src--setting--flow-editor.json";
import part319 from "./en/src--setting--flows.json";
import part320 from "./en/src--setting--freight.json";
import part321 from "./en/src--setting--fulfillment-cutoff.json";
import part322 from "./en/src--setting--globale-settings.json";
import part323 from "./en/src--setting--groups.json";
import part324 from "./en/src--setting--idf-shipping-settings.json";
import part325 from "./en/src--setting--indigo8-settings.json";
import part326 from "./en/src--setting--inmar-settings.json";
import part327 from "./en/src--setting--international--components.json";
import part328 from "./en/src--setting--international--hooks.json";
import part329 from "./en/src--setting--international.json";
import part330 from "./en/src--setting--inventory-management.json";
import part331 from "./en/src--setting--katana-settings.json";
import part332 from "./en/src--setting--klaviyo-settings--hooks.json";
import part333 from "./en/src--setting--klaviyo-settings.json";
import part334 from "./en/src--setting--label-flow.json";
import part335 from "./en/src--setting--location-flow--rate-source-selection--components.json";
import part336 from "./en/src--setting--location-flow--rate-source-selection.json";
import part337 from "./en/src--setting--location-flow.json";
import part338 from "./en/src--setting--loop-settings.json";
import part339 from "./en/src--setting--loopz-settings--hooks.json";
import part340 from "./en/src--setting--loopz-settings.json";
import part341 from "./en/src--setting--managed-returns.json";
import part342 from "./en/src--setting--marketing--email-domain.json";
import part343 from "./en/src--setting--marketing--integrations.json";
import part344 from "./en/src--setting--marketing--subscribe-keywords.json";
import part345 from "./en/src--setting--marketing.json";
import part346 from "./en/src--setting--merchant-recommended-exchanges--components.json";
import part347 from "./en/src--setting--mintsoft-settings.json";
import part348 from "./en/src--setting--narvar-settings.json";
import part349 from "./en/src--setting--netsuite-settings--sections.json";
import part350 from "./en/src--setting--netsuite-settings.json";
import part351 from "./en/src--setting--odoo-settings.json";
import part352 from "./en/src--setting--oms--automations.json";
import part353 from "./en/src--setting--oms--work-order-flows.json";
import part354 from "./en/src--setting--order-editing.json";
import part355 from "./en/src--setting--order-tracking.json";
import part356 from "./en/src--setting--permissions.json";
import part357 from "./en/src--setting--point-of-sale.json";
import part358 from "./en/src--setting--product.json";
import part359 from "./en/src--setting--products-as-variants--components.json";
import part360 from "./en/src--setting--products-as-variants--utils.json";
import part361 from "./en/src--setting--products-as-variants.json";
import part362 from "./en/src--setting--purple-dot-settings.json";
import part363 from "./en/src--setting--recover.json";
import part364 from "./en/src--setting--redo-supplies--shipping-rules.json";
import part365 from "./en/src--setting--refundid-settings.json";
import part366 from "./en/src--setting--refunds.json";
import part367 from "./en/src--setting--return-flow--condition-types.json";
import part368 from "./en/src--setting--return-flow--hooks.json";
import part369 from "./en/src--setting--return-flow--translations.json";
import part370 from "./en/src--setting--return-flow.json";
import part371 from "./en/src--setting--return-processing-flows.json";
import part372 from "./en/src--setting--returns--coverage--package-protection.json";
import part373 from "./en/src--setting--returns--coverage.json";
import part374 from "./en/src--setting--returns--labels.json";
import part375 from "./en/src--setting--returns--locations.json";
import part376 from "./en/src--setting--returns--operations--ecommerce--shopify.json";
import part377 from "./en/src--setting--returns--operations--orders.json";
import part378 from "./en/src--setting--returns--operations--processing.json";
import part379 from "./en/src--setting--returns--operations.json";
import part380 from "./en/src--setting--returns--policies.json";
import part381 from "./en/src--setting--returns--portal--exchange-ui.json";
import part382 from "./en/src--setting--returns--portal--pricing.json";
import part383 from "./en/src--setting--returns--portal.json";
import part384 from "./en/src--setting--returns--warehouse.json";
import part385 from "./en/src--setting--returns-ui.json";
import part386 from "./en/src--setting--returns.json";
import part387 from "./en/src--setting--rise-ai-settings.json";
import part388 from "./en/src--setting--rivo-settings.json";
import part389 from "./en/src--setting--ryder-settings--hooks.json";
import part390 from "./en/src--setting--ryder-settings.json";
import part391 from "./en/src--setting--seko-settings.json";
import part392 from "./en/src--setting--shipbob-settings--hooks.json";
import part393 from "./en/src--setting--shipbob-settings.json";
import part394 from "./en/src--setting--shipedge-settings.json";
import part395 from "./en/src--setting--shiphero-settings.json";
import part396 from "./en/src--setting--shipping--components.json";
import part397 from "./en/src--setting--shipping--sections.json";
import part398 from "./en/src--setting--shipping.json";
import part399 from "./en/src--setting--tag-exclusion-rules.json";
import part400 from "./en/src--setting--teamwork-commerce-settings.json";
import part401 from "./en/src--setting--trackstar-settings.json";
import part402 from "./en/src--setting--unified-billing--hooks.json";
import part403 from "./en/src--setting--unified-billing--overview.json";
import part404 from "./en/src--setting--unified-billing--transactions--components--filters.json";
import part405 from "./en/src--setting--unified-billing--transactions--components.json";
import part406 from "./en/src--setting--unified-billing--transactions.json";
import part407 from "./en/src--setting--unified-billing.json";
import part408 from "./en/src--setting--user-groups.json";
import part409 from "./en/src--setting--variant-exchange-guidance--components.json";
import part410 from "./en/src--setting--variant-exchange-guidance--utils.json";
import part411 from "./en/src--setting.json";
import part412 from "./en/src--utils.json";
import part413 from "./en/support--app--src--gmail.json";
import part414 from "./en/support--app--src--setting--channel.json";
import part415 from "./en/support--app--src--setting--chat-flow.json";
import part416 from "./en/support--app--src--setting--general--components.json";
import part417 from "./en/support--app--src--setting--general.json";
import part418 from "./en/support--app--src--setting--rules--components.json";
import part419 from "./en/support--app--src--setting--rules--conditions.json";
import part420 from "./en/support--app--src--setting--rules--flow-editor--actions.json";
import part421 from "./en/support--app--src--setting--rules--flow-editor--conditions.json";
import part422 from "./en/support--app--src--setting--rules--flow-editor.json";
import part423 from "./en/support--app--src--setting--rules.json";
import part424 from "./en/support--app--src--setting.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
  part9,
  part10,
  part11,
  part12,
  part13,
  part14,
  part15,
  part16,
  part17,
  part18,
  part19,
  part20,
  part21,
  part22,
  part23,
  part24,
  part25,
  part26,
  part27,
  part28,
  part29,
  part30,
  part31,
  part32,
  part33,
  part34,
  part35,
  part36,
  part37,
  part38,
  part39,
  part40,
  part41,
  part42,
  part43,
  part44,
  part45,
  part46,
  part47,
  part48,
  part49,
  part50,
  part51,
  part52,
  part53,
  part54,
  part55,
  part56,
  part57,
  part58,
  part59,
  part60,
  part61,
  part62,
  part63,
  part64,
  part65,
  part66,
  part67,
  part68,
  part69,
  part70,
  part71,
  part72,
  part73,
  part74,
  part75,
  part76,
  part77,
  part78,
  part79,
  part80,
  part81,
  part82,
  part83,
  part84,
  part85,
  part86,
  part87,
  part88,
  part89,
  part90,
  part91,
  part92,
  part93,
  part94,
  part95,
  part96,
  part97,
  part98,
  part99,
  part100,
  part101,
  part102,
  part103,
  part104,
  part105,
  part106,
  part107,
  part108,
  part109,
  part110,
  part111,
  part112,
  part113,
  part114,
  part115,
  part116,
  part117,
  part118,
  part119,
  part120,
  part121,
  part122,
  part123,
  part124,
  part125,
  part126,
  part127,
  part128,
  part129,
  part130,
  part131,
  part132,
  part133,
  part134,
  part135,
  part136,
  part137,
  part138,
  part139,
  part140,
  part141,
  part142,
  part143,
  part144,
  part145,
  part146,
  part147,
  part148,
  part149,
  part150,
  part151,
  part152,
  part153,
  part154,
  part155,
  part156,
  part157,
  part158,
  part159,
  part160,
  part161,
  part162,
  part163,
  part164,
  part165,
  part166,
  part167,
  part168,
  part169,
  part170,
  part171,
  part172,
  part173,
  part174,
  part175,
  part176,
  part177,
  part178,
  part179,
  part180,
  part181,
  part182,
  part183,
  part184,
  part185,
  part186,
  part187,
  part188,
  part189,
  part190,
  part191,
  part192,
  part193,
  part194,
  part195,
  part196,
  part197,
  part198,
  part199,
  part200,
  part201,
  part202,
  part203,
  part204,
  part205,
  part206,
  part207,
  part208,
  part209,
  part210,
  part211,
  part212,
  part213,
  part214,
  part215,
  part216,
  part217,
  part218,
  part219,
  part220,
  part221,
  part222,
  part223,
  part224,
  part225,
  part226,
  part227,
  part228,
  part229,
  part230,
  part231,
  part232,
  part233,
  part234,
  part235,
  part236,
  part237,
  part238,
  part239,
  part240,
  part241,
  part242,
  part243,
  part244,
  part245,
  part246,
  part247,
  part248,
  part249,
  part250,
  part251,
  part252,
  part253,
  part254,
  part255,
  part256,
  part257,
  part258,
  part259,
  part260,
  part261,
  part262,
  part263,
  part264,
  part265,
  part266,
  part267,
  part268,
  part269,
  part270,
  part271,
  part272,
  part273,
  part274,
  part275,
  part276,
  part277,
  part278,
  part279,
  part280,
  part281,
  part282,
  part283,
  part284,
  part285,
  part286,
  part287,
  part288,
  part289,
  part290,
  part291,
  part292,
  part293,
  part294,
  part295,
  part296,
  part297,
  part298,
  part299,
  part300,
  part301,
  part302,
  part303,
  part304,
  part305,
  part306,
  part307,
  part308,
  part309,
  part310,
  part311,
  part312,
  part313,
  part314,
  part315,
  part316,
  part317,
  part318,
  part319,
  part320,
  part321,
  part322,
  part323,
  part324,
  part325,
  part326,
  part327,
  part328,
  part329,
  part330,
  part331,
  part332,
  part333,
  part334,
  part335,
  part336,
  part337,
  part338,
  part339,
  part340,
  part341,
  part342,
  part343,
  part344,
  part345,
  part346,
  part347,
  part348,
  part349,
  part350,
  part351,
  part352,
  part353,
  part354,
  part355,
  part356,
  part357,
  part358,
  part359,
  part360,
  part361,
  part362,
  part363,
  part364,
  part365,
  part366,
  part367,
  part368,
  part369,
  part370,
  part371,
  part372,
  part373,
  part374,
  part375,
  part376,
  part377,
  part378,
  part379,
  part380,
  part381,
  part382,
  part383,
  part384,
  part385,
  part386,
  part387,
  part388,
  part389,
  part390,
  part391,
  part392,
  part393,
  part394,
  part395,
  part396,
  part397,
  part398,
  part399,
  part400,
  part401,
  part402,
  part403,
  part404,
  part405,
  part406,
  part407,
  part408,
  part409,
  part410,
  part411,
  part412,
  part413,
  part414,
  part415,
  part416,
  part417,
  part418,
  part419,
  part420,
  part421,
  part422,
  part423,
  part424,
);
